import { render, staticRenderFns } from "./SysDict.vue?vue&type=template&id=b96f9f08&scoped=true"
import script from "./SysDict.vue?vue&type=script&lang=js"
export * from "./SysDict.vue?vue&type=script&lang=js"
import style0 from "./SysDict.vue?vue&type=style&index=0&id=b96f9f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96f9f08",
  null
  
)

export default component.exports